import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Picker, Cell, Infiniteloading, Popup, Toast, Dialog, Textinput } from '@nutui/nutui'
import { Button, Carousel, CarouselItem, Tabs, TabPane, Pagination, Input } from 'element-ui'
// import NutUI from '@nutui/nutui'
import '@nutui/nutui/dist/nutui.css'
// import { Row as ViewRow, Col as ViewCol, Button, Input, Icon } from 'view-design'
import './assets/css/reset.css'
import './assets/css/iconfont.css'
// import 'view-design/dist/styles/iview.css'

import Highchart from 'highcharts/highcharts'
import HighchartsVue from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'

stockInit(Highchart)
Vue.use(HighchartsVue)
Picker.install(Vue)
Cell.install(Vue)
Infiniteloading.install(Vue)
Popup.install(Vue)
Dialog.install(Vue)
Textinput.install(Vue)
Vue.prototype.$toast = Toast
// NutUI.install(Vue)

// Vue.component('ViewRow', ViewRow)
// Vue.component('ViewCol', ViewCol)
// Vue.component('Button', Button)
// Vue.component('Input', Input)
// Vue.component('Icon', Icon)
// Vue.component('Page', ViewPage)
// console.log(ViewPage)
Vue.component(Button.name, Button)
Vue.component(Carousel.name, Carousel)
Vue.component(CarouselItem.name, CarouselItem)
Vue.component(Tabs.name, Tabs)
Vue.component(TabPane.name, TabPane)
Vue.component(Pagination.name, Pagination)
Vue.component(Input.name, Input)

Vue.config.productionTip = false
Vue.mixin({
  methods: {
    encryptName (str) {
      if (!str) return '--'
      return str.split('').map((item, index) => {
        return (index > 2 || (str.length <= 3 && index > 0) || (str.length === 1)) ? '*' : item
      }).join('')
    }
  },
  filters: {
    transformTime (data) {
      data = data + ''
      while (data.length < 13) {
        data = data + '0'
      }
      function add0 (m) { return m < 10 ? '0' + m : m }
      var time = new Date(Number(data))
      var y = time.getFullYear()
      var m = time.getMonth() + 1
      var d = time.getDate()
      return y + '-' + add0(m) + '-' + add0(d)
    },
    tranUnit (val) {
      return val < 10000 ? val : val / 10000 + '万'
    }
  }
})
export default new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
